var coll = document.getElementsByClassName("list-item__text--collapsible-wizard");
var i;

for (i = 0; i < coll.length; i++) {
  if (coll[i].classList.contains("active-collapsible-wizard")) {
    coll[i].nextElementSibling.style.maxHeight = coll[i].nextElementSibling.scrollHeight + "px";
  }
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active-collapsible-wizard");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}